export default {
  flagColumn: {
    paddingRight: 0
  },
  conditionColumn: {
    paddingLeft: 2
  }
};



// WEBPACK FOOTER //
// ./app/modules/parts/components/ModifiedFlag/ModifiedFlag.style.js